(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/progress-bar/assets/react/progress-bar.js') >= 0) return;  svs.modules.push('/components/numbergames/progress-bar/assets/react/progress-bar.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  StepIndicator,
  Step
} = svs.ui.ReactStepIndicator;
const {
  useEffect,
  useRef,
  useCallback,
  useMemo
} = React;
const productMapping = svs.numbergames.productMapping;
const {
  useTimeDiff
} = svs.numbergames.progress_bar.hooks;
const {
  trackStepClick,
  trackAnimationDone,
  trackCorrectionComplete
} = svs.numbergames.progress_bar;
const ENTER_KEY = 'Enter';
const SPACE_KEY = ' ';
const KEY_LEFT = 'ArrowLeft';
const KEY_RIGHT = 'ArrowRight';
const ProgressBar = _ref => {
  let {
    branding,
    steps,
    activeStepIndex,
    isActiveStepProgressStarted,
    isActiveStepProgressComplete,
    productName,
    onProgressBarAnimationEnd,
    onStepClick,
    winAmount,
    examined,
    trackingCategory: category,
    duration,
    displayShowDirect = true,
    isVideoCorrection = false,
    children
  } = _ref;
  const getStepTimeDiff = useTimeDiff(isActiveStepProgressStarted, activeStepIndex);
  const getWaitTimeDiff = useTimeDiff(isActiveStepProgressComplete, activeStepIndex);
  const hasExtraButton = Boolean(children);
  const numberOfSteps = steps.length;
  const lastStepIndex = numberOfSteps - 1;
  const selectedStepIndex = activeStepIndex + (isActiveStepProgressComplete ? 1 : 0);
  const userInteractionRef = useRef([]);
  const examinedRef = useRef(examined);
  const stepWaitTime = useMemo(() => {
    if (numberOfSteps === 2) {
      return '2s';
    }
    if (productMapping.isKeno(productName)) {
      return '4s';
    }
    return '8s';
  }, [numberOfSteps, productName]);
  const handleAnimationEnd = useCallback(() => {
    trackAnimationDone({
      category,
      stepTime: getStepTimeDiff(),
      waitTime: getWaitTimeDiff(),
      currentStep: {
        title: steps[activeStepIndex].title
      }
    });
    onProgressBarAnimationEnd === null || onProgressBarAnimationEnd === void 0 || onProgressBarAnimationEnd();
  }, [activeStepIndex, onProgressBarAnimationEnd, steps, category, getStepTimeDiff, getWaitTimeDiff]);
  const handleClick = clickedIndex => {
    const stepsInfo = {
      currentStep: {
        stepNr: activeStepIndex + 1,
        title: steps[activeStepIndex].title
      },
      clickedStep: {
        stepNr: clickedIndex + 1,
        title: steps[clickedIndex].title
      }
    };
    userInteractionRef.current.push(stepsInfo);
    trackStepClick(_objectSpread({
      category,
      stepTime: getStepTimeDiff(),
      waitTime: getWaitTimeDiff(),
      numberOfSteps
    }, stepsInfo));
    onStepClick === null || onStepClick === void 0 || onStepClick(clickedIndex);
  };
  useEffect(() => {
    if (activeStepIndex === lastStepIndex) {
      if (!examinedRef.current) {
        examinedRef.current = true;
        trackCorrectionComplete({
          category,
          winAmount,
          numberOfSteps,
          userInteraction: userInteractionRef.current,
          isVideoCorrection
        });
      }
      userInteractionRef.current = [];
    }
  }, [activeStepIndex, numberOfSteps, lastStepIndex, category, winAmount, isVideoCorrection]);
  const handleKeyDown = (e, index) => {
    var _document$activeEleme, _document$activeEleme2;
    switch (e.key) {
      case ENTER_KEY:
      case SPACE_KEY:
        if (index !== selectedStepIndex || isActiveStepProgressStarted) {
          e.preventDefault();
          handleClick(index);
        }
        break;
      case KEY_LEFT:
        (_document$activeEleme = document.activeElement.previousElementSibling) === null || _document$activeEleme === void 0 || _document$activeEleme.focus();
        break;
      case KEY_RIGHT:
        (_document$activeEleme2 = document.activeElement.nextElementSibling) === null || _document$activeEleme2 === void 0 || _document$activeEleme2.focus();
        break;
      default:
    }
  };
  return React.createElement("div", {
    className: "ng-progress-bar ".concat(hasExtraButton ? '' : 'no-button')
  }, React.createElement("div", {
    className: "ng-step-indicator ".concat(numberOfSteps > 3 ? 'ng-step-indicator--steps-4' : '')
  }, React.createElement(StepIndicator, {
    block: true,
    branding: branding,
    isClosed: true,
    onAnimationEnd: handleAnimationEnd,
    useAnimation: isActiveStepProgressComplete,
    duration: duration !== null && duration !== void 0 ? duration : stepWaitTime
  }, steps.map((step, index) => React.createElement(Step, {
    tabIndex: 0,
    onKeyDown: e => handleKeyDown(e, index),
    className: "".concat(index === lastStepIndex ? 'step-result' : 'step-bet').concat(index !== selectedStepIndex || isActiveStepProgressStarted && displayShowDirect ? ' pointer' : ''),
    isSelected: index === selectedStepIndex,
    key: step.title,
    onClick: () => handleClick(index)
  }, displayShowDirect && index === selectedStepIndex && isActiveStepProgressStarted ? React.createElement("div", {
    className: "step-text active"
  }, React.createElement("div", {
    className: "text-title"
  }, step.title), React.createElement("span", null, React.createElement("div", {
    className: "text-show-direct"
  }, "Visa ", React.createElement("span", null, "direkt")))) : React.createElement("div", {
    className: "step-text"
  }, React.createElement("div", {
    className: "text-title"
  }, step.title)))))), hasExtraButton && React.createElement("div", {
    className: "ng-progress-bar-extra-button"
  }, React.createElement("div", {
    className: "ng-content"
  }, children)));
};
ProgressBar.defaultProps = {
  activeStepIndex: 0,
  branding: 'inverted',
  examined: true,
  winAmount: 0
};
svs.numbergames.progress_bar.ProgressBar = ProgressBar;

 })(window);